module.exports = __webpack_public_path__ + "media/images/backgrounds/login_bg_xl-e7358287dd889f67c9469c647fe3580b.png";